import moment from 'moment';
import type { AuditSummaryProps } from '../../../types';
import { getManualDayEntryEditability, type ManualDayEntryFormValues } from '../manualDayEntry';
import { resolveAuditSummaryMode } from './mode';
import type { AuditSummaryContext } from './types';

export function buildAuditSummaryContext({
  selectedShift = 'All Shift',
  date,
  auditTotals,
  dailyTotals,
  storeId,
  isLoading = false,
  isLoadingStores = false,
  isLoadingAcknowledgeAndVerified = false,
  hideCards = false,
  isBothConnected = false,
  isBothNotConnected = false,
  isLottoConnectedOnly = false,
  isPOSConnectedOnly = false,
  isPosValueMissing = false,
  posMissingScratcherSalesInput = '',
  posMissingScratcherQtyInput = '',
  posMissingLottoSalesInput = '',
  posMissingPayoutInput = '',
  manualFormValues,
}: Pick<
  AuditSummaryProps,
  | 'selectedShift'
  | 'date'
  | 'auditTotals'
  | 'dailyTotals'
  | 'storeId'
  | 'isLoading'
  | 'isLoadingStores'
  | 'isLoadingAcknowledgeAndVerified'
  | 'hideCards'
  | 'isBothConnected'
  | 'isBothNotConnected'
  | 'isLottoConnectedOnly'
  | 'isPOSConnectedOnly'
  | 'isPosValueMissing'
> & {
  posMissingScratcherSalesInput?: string;
  posMissingScratcherQtyInput?: string;
  posMissingLottoSalesInput?: string;
  posMissingPayoutInput?: string;
  manualFormValues: ManualDayEntryFormValues;
}): AuditSummaryContext {
  const isAllShift = selectedShift === 'All Shift';
  const businessDate = date ? moment(date).format('YYYY-MM-DD') : null;

  const mode = resolveAuditSummaryMode({
    isBothConnected,
    isBothNotConnected,
    isLottoConnectedOnly,
    isPOSConnectedOnly,
  });

  const manualDayEntryEditability = getManualDayEntryEditability({
    isBothNotConnected,
    isLottoConnectedOnly,
    isPOSConnectedOnly,
  });

  return {
    mode,
    isAllShift,
    storeId,
    businessDate,
    isLoading,
    isLoadingStores,
    isLoadingAcknowledgeAndVerified,
    hideCards,
    dailyTotals,
    auditTotals,
    isPosValueMissing,
    posMissingScratcherSalesInput,
    posMissingScratcherQtyInput,
    posMissingLottoSalesInput,
    posMissingPayoutInput,
    manualDayEntryEditability,
    manualFormValues,
  };
}

